import * as React from 'react';
import { getTranslator } from '../../Translator';
import { getPartyById, getCandidateById, getElectionById } from '../../selectors';
import { canVote } from '../../Election';
import { useAppSelector } from '../../hooks';

type VoteButtonProps = {
    candidateId: number;
    onClickVote(): void;
}

export const VoteButton = (props: VoteButtonProps) => {
    const { candidateId, onClickVote } = props;

    const candidates = useAppSelector(state => state.candidates);
    const parties = useAppSelector(state => state.parties);
    const elections = useAppSelector(state => state.elections);
    const language = useAppSelector(state => state.language);

    const candidate = getCandidateById(candidates, candidateId);
    const party = getPartyById(parties, candidate.PartyId);
    const election = getElectionById(elections, party.ElectionId);
    const userCanVote = canVote(election);
    const t = getTranslator(language);

    if (userCanVote) {
        return <button id="Candidate-Vote" type="button" className="button--important" onClick={onClickVote}>
            {t['Vote']}
        </button>
    } else {
        return <span className="linkbutton linkbutton--disabled">{t['Vote']}</span>
    }
}
